import apiClient from "./api-client";

export function getResponseHeader(headers, name) {
  if (!headers) return null;
  if (typeof headers.get === 'function') return headers.get(name);

  const target = name.toLowerCase();
  const key = Object.keys(headers).find((k) => k.toLowerCase() === target);
  return key ? headers[key] : null;
}

export function parseContentDisposition(cd, fallback = null) {
  if (!cd) return fallback;
  const utf8 = cd.match(/filename\*=UTF-8''(.+)/);
  if (utf8) return decodeURIComponent(utf8[1]);
  const ascii = cd.match(/filename="?([^"]+)"?/);
  if (ascii) return ascii[1];
  return fallback;
}

export function downloadBlob(blob, filename) {
  if (typeof window === 'undefined') return;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function getBlob(url, config = {}) {
  const res = await apiClient.get(url, {
    responseType: 'blob',
    ...config,
  });
  return res;
}
